import React from 'react'
import CartItems from '../Components/CartItems/CartItems'

function Cart() {
  return (
    <div className='cart'>
      <CartItems></CartItems>
    </div>
  )
}

export default Cart